import { render } from "./AddCurrencyModal.vue?vue&type=template&id=559bf880"
import script from "./AddCurrencyModal.vue?vue&type=script&lang=js"
export * from "./AddCurrencyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__